import { render, staticRenderFns } from "./DetalleEvento.vue?vue&type=template&id=0429fb1f&scoped=true&"
import script from "./DetalleEvento.vue?vue&type=script&lang=js&"
export * from "./DetalleEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0429fb1f",
  null
  
)

export default component.exports